import gql from 'graphql-tag';

import CollectionDescriptionFragment from 'bundles/enterprise-collections/queries/CollectionDescriptionFragment';

export const ConstantProductCardCourseFragment = gql`
  fragment ConstantProductCardCourseFragment on CoursesV1 {
    id
    promoPhoto: photoUrl
    name
    slug
    upcomingSessionStartDate
    partners {
      elements {
        id
        name
        logo
        squareLogo
        classLogo
      }
    }
    display
    courseTypeMetadata {
      id
      courseTypeMetadata {
        __typename
      }
    }
  }
`;

export const ConstantProductCardS12nFragment = gql`
  fragment ConstantProductCardS12nFragment on OnDemandSpecializationsV1 {
    id
    promoPhoto: logo
    name
    slug
    productVariant
    courseIds
    partners {
      elements {
        id
        name
        logo
        squareLogo
        classLogo
      }
    }
  }
`;

export const ProductCardItemFragment = gql`
  fragment ProductCardItemFragment on ProgramCurriculumCollectionsV1_org_coursera_program_curriculum_CurriculumCollectionItem {
    productId
    productState {
      ... on ProgramCurriculumCollectionsV1_programCourseWithStateMember {
        productState: programCourseWithState {
          courseId
          state
          isWishlisted
        }
      }
      ... on ProgramCurriculumCollectionsV1_programS12nWithStateMember {
        productState: programS12nWithState {
          s12nId
          state
          isWishlisted
        }
      }
    }
    clipId {
      courseId
      itemId
    }
  }
`;

export const ProductCardCollectionContextFragment = gql`
  fragment ProductCardCollectionContextFragment on ProgramCurriculumCollectionsV1_collectionContextMetadata {
    ... on ProgramCurriculumCollectionsV1_singleSkillMember {
      singleSkill {
        targetSkillProfileId
        skillId
      }
    }
  }
`;

export const ProductCardAssociatedSessionsFragment = gql`
  fragment ProductCardAssociatedSessionsFragment on OnDemandCourseSessionsV1 {
    courseId
    startsAt
    endsAt
  }
`;
export const CollectionDetailsFragment = gql`
fragment CollectionDetailsFragment on ProgramCurriculumCollectionsV1 {
  trackId
  courses {
    elements {
      ...ConstantProductCardCourseFragment
    }
  }
  s12ns {
    elements {
      ...ConstantProductCardS12nFragment
    }
  }
  items {
    ...ProductCardItemFragment
  }
  collectionContextMetadata {
    ...ProductCardCollectionContextFragment
  }
  associatedSessions {
    elements {
      ...ProductCardAssociatedSessionsFragment
    }
  }
}
${ConstantProductCardCourseFragment},
${ConstantProductCardS12nFragment},
${ProductCardItemFragment},
${ProductCardCollectionContextFragment}
${ProductCardAssociatedSessionsFragment}
`;

export const CollectionListItemFragment = gql`
  fragment CollectionListItemFragment on ProgramCurriculumCollectionsV1 {
    id
    title
    image
    courseIds
    s12nIds
    collectionTrackingId
    ...CollectionDescriptionFragment,
    ...CollectionDetailsFragment

  }
  ${CollectionDescriptionFragment},
  ${CollectionDetailsFragment}
`;

export const EnterpriseConfigurationCourseMetadataFragment = gql`
  fragment EnterpriseConfigurationMetadataFragment on EnterpriseProductConfigurationMetadataV1 {
    id
    metadataType {
      ... on EnterpriseProductConfigurationMetadataV1_courseMember {
        course {
          courseId
          hasMultipleOfferings
          isExclusive
          isRecommendedForCredit
          isSelectedForCredit
          isConfigurationAllowed
          isAutoEnrollmentEnabled
          configurationStatus
          isSelectedToRequireAllItemCompletion
        }
      }

      ... on EnterpriseProductConfigurationMetadataV1_specializationMember {
        specialization {
          s12nId
          isRecommendedForCredit
          isSelectedForCredit
          isConfigurationAllowed
          isAutoEnrollmentEnabled
          configurationStatus
          associatedSessionId
          isSelectedToRequireAllItemCompletion
        }
      }
    }
  }
`;

export const ProgramProductMetadataMultiGetQuery = gql`
  query CommonProgramProductMetadataMultiGetQuery($ids: [String!]!) {
    ProgramProductMetadataV1Resource {
      multiGet(ids: $ids) {
        elements {
          id
          programId
          metadataType {
            ... on ProgramProductMetadataV1_courseMember {
              course {
                isExclusive
                isSelectedForCredit
                courseId
              }
            }
          }
        }
      }
    }
  }
`;

export const EnterpriseProgramSessionAssociationsByProgramsAndCourseQuery = gql`
  query EnterpriseProgramSessionAssociationsByProgramsAndCourseQuery($courseId: String!, $programIds: [String!]!) {
    EnterpriseProgramSessionAssociationsV1Resource {
      byProgramsAndCourse(courseId: $courseId, programIds: $programIds) {
        elements {
          programId
          session {
            startsAt
            endsAt
          }
        }
      }
    }
  }
`;

export const ProgramProductMetadataFragment = gql`
  fragment ProgramProductMetadataFragment on ProgramProductMetadataV1 {
    id
    metadataType {
      ... on ProgramProductMetadataV1_courseMember {
        course {
          isExclusive
          isSelectedForCredit
          courseId
        }
      }
      ... on ProgramProductMetadataV1_specializationMember {
        specialization {
          s12nId
          isSelectedForCredit
          associatedSessionId
        }
      }
    }
  }
`;

export const ProgramSpecializationMetadataFragment = gql`
  fragment ProgramSpecializationMetadataFragment on ProgramProductMetadataV1_org_coursera_enterprise_curriculumbuilder_ProgramSpecializationMetadata {
    isSelectedForCredit
    s12nId
  }
`;

export const CourseAutoenrollmentModalQuery = gql`
  query CourseAutoenrollmentModalQuery($metadataIds: [String!]!) {
    ProgramProductMetadataV1Resource {
      multiGet(ids: $metadataIds) {
        elements {
          id
          programId
          metadataType {
            ... on ProgramProductMetadataV1_courseMember {
              course {
                isSelectedForCredit
                courseId
              }
            }
          }
        }
      }
    }
  }
`;
